module.exports = __webpack_public_path__ + "img/header-weddingRingsStylesRomantic.2c22562.jpg";